export default {
      id: "icon-youtube-usage",
      viewBox: "0 0 26 20",
      url: __webpack_public_path__ + "icons.svg#icon-youtube",
      toString: function () {
        return this.url;
      }
    }